const baseBudget = {
  leaseId: 'id-a1b2c3',
  vehicleRego: 'abc123',
  term: 36,
  currentMonth: 3,
  totalActual: 25,
  totalBudget: 100,
  totalVariance: 75,
  statementDocuments: [
    {
      url: 'http://www.africau.edu/images/default/sample.pdf',
      date: '2021-10-26T00:00:00.000Z'
    },
    {
      url: 'http://www.africau.edu/images/default/sample.pdf',
      date: '2021-09-25T00:00:00.000Z'
    },
    {
      url: 'http://www.africau.edu/images/default/sample.pdf',
      date: '2020-09-24T00:00:00.000Z'
    },
    {
      url: 'http://www.africau.edu/images/default/sample.pdf',
      date: '2021-01-12T00:00:00.000Z'
    }
  ],
  items: [
    {
      leaseId: 'id-a1b2c3',
      budgetCategory: 'Fuel',
      actual: 20,
      budget: 100,
      variance: 80
    },
    {
      leaseId: 'id-a1b2c3',
      budgetCategory: 'Tyres',
      actual: 82,
      budget: 184,
      variance: 102
    },
    {
      leaseId: 'id-a1b2c3',
      budgetCategory: 'Maintenance',
      actual: 0,
      budget: 500,
      variance: 500
    },
    {
      leaseId: 'id-a1b2c3',
      budgetCategory: 'Insurance',
      actual: 154,
      budget: 50,
      variance: -104
    },
    {
      leaseId: 'id-a1b2c3',
      budgetCategory: 'Registration',
      actual: 63,
      budget: 400,
      variance: 336
    }
  ]
};

const budgetTransactions = [
  {
    label: 'BT St Leonards',
    transactionAmount: -50.45,
    date: '2021-10-26T00:00:00.000Z'
  },
  {
    label: 'Metro Petrol',
    transactionAmount: -78.34,
    date: '2021-08-08T00:00:00.000Z'
  },
  {
    label: 'Fuel Leichardt',
    transactionAmount: -62.23,
    date: '2021-08-08T00:00:00.000Z'
  },
  {
    label: 'BT St Leonards',
    transactionAmount: -50.45,
    date: '2022-03-26T00:00:00.000Z'
  },
  {
    label: 'Petrol',
    transactionAmount: -21.99,
    date: '2021-08-05T00:00:00.000Z'
  },
  {
    label: 'BT St Leonards',
    transactionAmount: -50.45,
    date: '2022-10-26T00:00:00.000Z'
  },
  {
    label: 'Metro Petrol',
    transactionAmount: -86.6,
    date: '2021-08-02T00:00:00.000Z'
  },
  {
    label: 'BT St Leonards',
    transactionAmount: -50.45,
    date: '2021-12-26T00:00:00.000Z'
  },
  {
    label: 'Fuel Budget',
    transactionAmount: 200,
    date: '2021-04-15T00:00:00.000Z'
  },
  {
    label: 'Metro Petrol',
    transactionAmount: -67.23,
    date: '2021-01-28T00:00:00.000Z'
  },
  {
    label: 'BT St Leonards',
    transactionAmount: -50.45,
    date: '2021-11-26T00:00:00.000Z'
  },
  {
    label: 'Fuel Budget',
    transactionAmount: 200,
    date: '2021-01-26T00:00:00.000Z'
  }
];

export default {
  data: {
    getBudgetSummary: { ...baseBudget },
    getBudgetTransactions: [...budgetTransactions]
  }
};
